import ClientOAuth2 from 'client-oauth2';
import urlUtils from '../../utils/urlUtils.js';
const crypto = require('crypto');
import pkceStore from '../PkceStore/PkceStore.js';
import oAuthConstants from '../oAuthConstants.js';
import { reject } from 'async';

class SignIn {
    constructor(settings, args = {}) {
        this._setQuery(settings, args);
        settings.query = this.query;
        this.settings = new ClientOAuth2(settings);
    }

    _setQuery(settings, args) {
        this.query = {
            ...args,
            nonce: settings.nonce || 'nonce'
        };
    }

    signInSilentRequest_v2() {
        var query = this.query;
        query.prompt = 'none';
        var authorizationUri = this.settings.token.getUri({ query: query });
        authorizationUri = urlUtils.removeEmptyParams(authorizationUri);
        authorizationUri = urlUtils.setQueryParameter('user_type', urlUtils.getParameterByName('user_type'), authorizationUri);
        authorizationUri = urlUtils.setQueryParameter('locale_id', urlUtils.getParameterByName('locale_id'), authorizationUri || 'en-GB');
        authorizationUri = urlUtils.setQueryParameter('realm_id', urlUtils.getParameterByName('realm_id'), authorizationUri);
        authorizationUri = urlUtils.setQueryParameter('response_type', oAuthConstants.response_type, authorizationUri);
        authorizationUri = urlUtils.setQueryParameter('code_challenge', this.generateAndStoreCodeChallenge(oAuthConstants.code_challenge_method), authorizationUri);
        authorizationUri = urlUtils.setQueryParameter('code_challenge_method', oAuthConstants.code_challenge_method, authorizationUri);
        return Promise.resolve(authorizationUri);
    }

    readSignInResponse_v2(code) {
        return new Promise((resolve, reject) => {
            this.fetchAccessTokenFromCode(this.settings, code)
                .then((user) => {
                    resolve(user);
                }, (err) => {
                    console.log("fetchAccessTokenFromCode : Error while getting accesss token : ", err);
                    reject(err);
                });
            return;

        });
    }

    generateAndStoreCodeChallenge(hashMethod) {
        var codeVerifier = generateRandomCodeVerfier();
        var codeChallenge = generateCodeChallenge(codeVerifier, hashMethod);
        pkceStore.keepCodeVerifier(codeVerifier);
        return codeChallenge;
    }

    fetchAccessTokenFromCode(config, code) {
        let data = "client_id=" + oAuthConstants.clientId +
            "&grant_type=" + oAuthConstants.grant_type_v2 +
            "&code=" + code +
            "&redirect_uri=" + encodeURIComponent(oAuthConstants.redirectUri) +
            "&code_verifier=" + pkceStore.fetchCodeVerifierFromLocal();

        return fetch(config.options.token_endpoint, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: data
        })
            .then(res => res.json())
            .then(
                (result) => {
                    pkceStore.clearCodeVerifier();
                    return result;
                });
    }
}

export default SignIn;

function base64URLEncode(str) {
    // return str.toString('base64');
    return str.toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}

function sha256(buffer, hashMethod) {
    return crypto.createHash(hashMethod).update(buffer).digest();
}

export const generateCodeChallenge = (codeVerifier, hashMethod) => {
    if (hashMethod == 'S256')
        return base64URLEncode(sha256(codeVerifier, 'sha256'));
    else
        return codeVerifier;
}

export const generateRandomCodeVerfier = () => {
    return base64URLEncode(crypto.randomBytes(32));

}